export default "__VITE_ASSET__Bn026bCq__"